/* eslint-disable */
import * as icon from 'vue-svgicon'
icon.register({
  'target': {
    width: 16,
    height: 16,
    viewBox: '0 0 48 48',
    data: '<path pid="0" d="M19.251 24.5h1.619a3.173 3.173 0 0 0 3.131 2.681A3.18 3.18 0 0 0 27.182 24a3.174 3.174 0 0 0-2.681-3.131V19.25c2.413.253 4.3 2.27 4.3 4.75a4.8 4.8 0 0 1-4.8 4.8c-2.481 0-4.497-1.887-4.75-4.3zM24 14.106a9.822 9.822 0 0 0-4.994 1.364l1.853 1.854a7.302 7.302 0 0 1 2.364-.667L24.5 15.38v1.261c3.844.258 6.885 3.45 6.885 7.36A7.385 7.385 0 0 1 24 31.386c-3.91 0-7.102-3.041-7.36-6.885h-1.261l1.277-1.277a7.327 7.327 0 0 1 .667-2.364l-1.854-1.853a9.832 9.832 0 0 0-1.363 4.994c0 5.464 4.43 9.894 9.894 9.894s9.894-4.43 9.894-9.894-4.43-9.895-9.894-9.895zm-3.707 7.601L19 23h4v-4l-1.293 1.293L16.415 15 15 16.415l5.293 5.292zM25 24a1 1 0 1 0-2 0 1 1 0 0 0 2 0z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/target.js